import { render, staticRenderFns } from "./TdChild.vue?vue&type=template&id=f011e1be&scoped=true"
import script from "./TdChild.vue?vue&type=script&lang=js"
export * from "./TdChild.vue?vue&type=script&lang=js"
import style0 from "./TdChild.vue?vue&type=style&index=0&id=f011e1be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f011e1be",
  null
  
)

export default component.exports